



























































































import { Component, Vue } from "vue-property-decorator";
import { apiService, Interfaces, AppConstants, Models } from "@/core/Export";
import store from "@/store";
import SupportTooltip from "@/components/Support/SupportTooltip.vue";
@Component({
  components: { SupportTooltip },
})
export default class Reports extends Vue {
  reportsTypesDataSource: Array<any>;
  reportModel: Models.Reports;
  reportLayoutsTypesDataSource: Array<any>;
  reportLayoutsTypesDataSourceFilterd: Array<any>;
  monthSelectOptions: Array<any>;
  yearSelectOptions: Array<any>;
  sortingAndFilteringDataSource: Array<any>;
  dateMask: string;
  daysOrHoursDataSource: Array<any>;
  reportFormat: string = "";
  reportFormatId: number = 0;
  isAttendSumCustomerReport: boolean = false;
  isCustomerReportFilterVisible: boolean = false;
  fileExt: string = "pdf";
  includingIndirectEmployees: boolean = false;
  employeesListIncludeIndirectEmployees: Array<number>;

  constructor() {
    super();
    this.dateMask = "DD/MM/YYYY";
    this.reportsTypesDataSource = new Array<any>();
    this.daysOrHoursDataSource = new Array<any>();
    this.reportLayoutsTypesDataSource = new Array<any>();
    this.reportLayoutsTypesDataSourceFilterd = new Array<any>();
    this.sortingAndFilteringDataSource = new Array<any>();
    this.reportModel = new Models.Reports();
    this.reportModel.year = this.selectedYear;
    this.reportModel.month = this.selectedMonth;
    this.reportModel.reportTypeCode = AppConstants.ReportCodes.Attend_Detail;
    this.reportModel.dataHoursOrDays = "hours";

    this.yearSelectOptions = [
      {
        label: (this.selectedYear - 1).toString(),
        value: this.selectedYear - 1,
      },
      {
        label: this.selectedYear.toString(),
        value: this.selectedYear,
      },
      {
        label: (this.selectedYear + 1).toString(),
        value: this.selectedYear + 1,
      },
    ];

    this.monthSelectOptions = this.generateMonths(1, 12);
    this.employeesListIncludeIndirectEmployees = [];
  }

  created() {
    this.onFillDataSources();
    this.onGetReportsLayoutsTypes();
  }

  onGetReportsLayoutsTypes() {
    this.appEnv.isBusy = true;
    apiService
      .getReportItems()
      .then((res) => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.reportLayoutsTypesDataSource = call.callResult.data;
          this.filterdReportLayoutsTypesDataSource();
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onReportTypeChanged(e) {
    let currentDate = new Date();
    switch (this.reportModel.reportTypeCode) {
      case AppConstants.ReportCodes.Attend_Daily:
        this.reportModel.fromDateStr = this.appEnv.formatDate(currentDate);
        this.reportModel.fromDate = this.appEnv.toUTC(
          this.reportModel.fromDateStr
        );

        this.reportModel.toDateStr = this.appEnv.formatDate(currentDate);
        this.reportModel.toDate = this.appEnv.toUTC(this.reportModel.toDateStr);
        break;
      case AppConstants.ReportCodes.Attend_Exceptions:
      case AppConstants.ReportCodes.Attend_Health_Declaration:
        let firstDateInMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        let yesterday = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() - 1
        );

        this.reportModel.fromDateStr = this.appEnv.formatDate(firstDateInMonth);
        this.reportModel.fromDate = this.appEnv.toUTC(
          this.reportModel.fromDateStr
        );

        this.reportModel.toDateStr = this.appEnv.formatDate(yesterday);
        this.reportModel.toDate = this.appEnv.toUTC(this.reportModel.toDateStr);
        break;
      default:
        this.reportModel.fromDateStr = null;
        this.reportModel.fromDate = null;
        this.reportModel.toDateStr = null;
        this.reportModel.toDate = null;
        break;
    }
    // this.reportModel.layoutId = 0;

    if (!this.isAttendSumCustomerReport) {
      this.reportModel.month = null;
      this.reportModel.year = null;
    }

    this.reportModel.sortBy = 0;
    this.reportModel.thenBy = 0;

    this.reportModel.dynamicSortBy = "";
    this.reportModel.dynamicThenBy = "";

    this.reportFormat = "";
    this.reportFormatId = 0;
    this.isCustomerReportFilterVisible = false;

    this.filterdReportLayoutsTypesDataSource();
  }

  onViewReport(e) {
    e.preventDefault();
    if (this.currentSelectedEmployees.length <= 0) {
      this.appEnv.showErrorDialog([
        { message: this.$t("msgs.reportEmpNotChoosen") },
      ]);
    } else if (this.currentSelectedEmployees.length > 500) {
      this.appEnv.showErrorDialog([
        { message: this.$t("msgs.toManyEmployees") },
      ]);
    } else {
      if (this.includingIndirectEmployees) {
        this.reportModel.employeeIds = this.employeesListIncludeIndirectEmployees;
      } else {
        this.reportModel.employeeIds = new Array<any>();
        this.currentSelectedEmployees.forEach((employee) => {
          this.reportModel.employeeIds.push(employee.id);
        });
      }

      if (this.isCustomerReportFilterVisible) {
        this.reportModel["dynamicReportId"] = this.reportFormatId;
        this.reportModel["layoutId"] = 0;
      } else {
        this.reportModel["layoutId"] = this.reportFormatId;
        this.reportModel["dynamicReportId"] = 0;
      }

      let fileName = null;
      if (this.fileExt == "xlsx" && this.reportModel["dynamicReportId"] > 0) {
        let report = this.reportLayoutsTypesDataSource.find(x => x.dynamicReportId == this.reportModel["dynamicReportId"]);
        fileName = report.name;
      }

      // if the environment is kiosk push to another page to show the report
      this.appEnv.getReport(this.reportModel, this.fileExt).then((url) => {
        if (!url) return;
        if (!AppConstants.IsKioskMode) {
          if (this.fileExt == "xlsx" && fileName) {
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.href = url;
            a.download = fileName + ".xls";
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
          }
          else window.open(url, "_blank");
        } else {
          this.$router.push({
            name: AppConstants.Routes.R_AttendReport,
            params: {
              reportUrl: url,
            },
          });
        }
      });
    }
  }

  onChangeIncludingIndirectEmployees() {
    if (this.includingIndirectEmployees) {
      let employeeIds = new Array<any>();
      this.currentSelectedEmployees.forEach((employee) => {
        employeeIds.push(employee.id);
      });
      this.onGetManagerEmployeesIncludingIndirectEmployees(employeeIds);
    }
  }

  onGetManagerEmployeesIncludingIndirectEmployees(employeeIds: Array<number>) {
    this.appEnv.isBusy = true;
    apiService
      .getManagerEmployeesIncludingIndirectEmployees(employeeIds)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.employeesListIncludeIndirectEmployees = call.callResult.data;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .finally(() => {
        this.appEnv.isBusy = false;
      });
  }

  onReportFormatChanged(value) {
    let [type, id] = value.split("_");
    this.reportFormatId = parseInt(id);
    if (type == "customer") {
      this.isAttendSumCustomerReport = true;
      this.reportModel.thenBy = 0;
      this.reportModel.thenBy = 0;
      this.isCustomerReportFilterVisible = true;
    } else {
      this.isAttendSumCustomerReport = false;
      this.reportModel.dynamicSortBy = "";
      this.reportModel.dynamicThenBy = "";
      this.isCustomerReportFilterVisible = false;
    }

    if (type == "customer" && this.reportModel.reportTypeCode == "ATTEND_SUM") {
      this.reportModel.month = null;
      this.reportModel.year = null;
    }
  }

  onFromDateChanged() {
    let qFromDateProxy = this.$refs.qFromDateProxy as any;
    qFromDateProxy.hide();
    this.reportModel.fromDate = this.appEnv.toUTC(this.reportModel.fromDateStr);
  }

  onToDateChanged() {
    let qToDateProxy = this.$refs.qToDateProxy as any;
    qToDateProxy.hide();
    this.reportModel.toDate = this.appEnv.toUTC(this.reportModel.toDateStr);
  }

  onCloseReportsDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
  }

  onFillDataSources() {
    this.daysOrHoursDataSource.push({
      label: this.$t("reportPrint.hours"),
      value: "hours",
    });

    this.daysOrHoursDataSource.push({
      label: this.$t("reportPrint.days"),
      value: "days",
    });

    this.reportsTypesDataSource.push({
      value: AppConstants.ReportCodes.Attend_Detail,
      label: this.$t("reportPrint.detail"),
      supportText: "supportText.reportPrintDetailSupport",
    });

    this.reportsTypesDataSource.push({
      value: AppConstants.ReportCodes.Attend_Daily,
      label: this.$t("reportPrint.daily"),
      supportText: "supportText.reportPrintDailySupport",
    });

    this.reportsTypesDataSource.push({
      value: AppConstants.ReportCodes.Attend_Sum,
      label: this.$t("reportPrint.merukaz"),
      supportText: "supportText.reportPrintMerukazSupport",
    });

    this.reportsTypesDataSource.push({
      value: AppConstants.ReportCodes.Attend_Exceptions,
      label: this.$t("reportPrint.harigim"),
    });

    this.reportsTypesDataSource.push({
      value: AppConstants.ReportCodes.Attend_Events,
      label: this.$t("reportPrint.events"),
      supportText: "supportText.reportPrintEventsSupport",
    });

    this.reportsTypesDataSource.push({
      value: AppConstants.ReportCodes.Attend_Health_Declaration,
      label: this.$t("reportPrint.health_declaration"),
    });

    this.filterReportsByPermission();

    this.sortingAndFilteringDataSource.push({
      label: "",
      value: 0,
    });
    this.sortingAndFilteringDataSource.push({
      label: this.$t("fields.orgStructId"),
      value:
        AppConstants.AttendReportPrintDetailsSortOrFiltringFields.OrgStructName,
    });
    this.sortingAndFilteringDataSource.push({
      label: this.$t("fields.salaryFactoryNo"),
      value:
        AppConstants.AttendReportPrintDetailsSortOrFiltringFields
          .SalaryFactoryNo,
    });
    this.sortingAndFilteringDataSource.push({
      label: this.$t("fields.salaryNo"),
      value: AppConstants.AttendReportPrintDetailsSortOrFiltringFields.SalaryNo,
    });
  }

  filterReportsByPermission() {
    let allowedReports = this.appEnv.UserInfo
      .availableReportTypesCodes as Array<any>;
    if (allowedReports.length > 0) {
      let newReportsTypesDataSource = [];
      allowedReports.forEach((allowedReport) => {
        let report = this.reportsTypesDataSource.find(
          (q) => q.value == allowedReport
        );
        if (report) {
          newReportsTypesDataSource.push(report);
        }
      });

      this.reportsTypesDataSource = newReportsTypesDataSource;
    }
  }

  generateMonths(start, end) {
    var months = [];
    for (var month = start; month <= end; month++) {
      months.push({
        label: this.$t("months." + month.toString()),
        value: month,
      });
    }
    return months;
  }

  get customerFiltersDataSource() {
    let reportItem = this.reportLayoutsTypesDataSource.find(
      (q) => q.dynamicReportId === this.reportFormatId
    );
    if (reportItem) {
      return reportItem.sortDataSource.map((q) => {
        return { value: q.code, label: q.name };
      });
    }
    return [];
  }

  get isDataHoursOrDaysVisible() {
    return (
      this.reportModel.reportTypeCode == AppConstants.ReportCodes.Attend_Events
    );
  }

  get isFromDateToDateVisible() {
    return (
      this.reportModel.reportTypeCode ==
      AppConstants.ReportCodes.Attend_Daily ||
      this.reportModel.reportTypeCode ==
      AppConstants.ReportCodes.Attend_Exceptions ||
      this.reportModel.reportTypeCode ==
      AppConstants.ReportCodes.Attend_Health_Declaration
    );
  }

  get isSortByThenByVisible() {
    return (
      this.reportModel.reportTypeCode ==
      AppConstants.ReportCodes.Attend_Detail ||
      this.reportModel.reportTypeCode == AppConstants.ReportCodes.Attend_Events
    );
  }

  get isYearAndMonthVisible() {
    return (
      this.reportModel.reportTypeCode !=
      AppConstants.ReportCodes.Attend_Daily &&
      this.reportModel.reportTypeCode !=
      AppConstants.ReportCodes.Attend_Exceptions &&
      this.reportModel.reportTypeCode !=
      AppConstants.ReportCodes.Attend_Health_Declaration
    );
  }

  filterdReportLayoutsTypesDataSource() {
    let arr = [];
    switch (this.reportModel.reportTypeCode) {
      case AppConstants.ReportCodes.Attend_Detail:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) => s.reportTypeCode == AppConstants.ReportCodes.Attend_Detail
        );
        break;
      case AppConstants.ReportCodes.Attend_Sum:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) => s.reportTypeCode == AppConstants.ReportCodes.Attend_Sum
        );
        break;
      case AppConstants.ReportCodes.Attend_Daily:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) => s.reportTypeCode == AppConstants.ReportCodes.Attend_Daily
        );
        break;
      case AppConstants.ReportCodes.Attend_Exceptions:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) => s.reportTypeCode == AppConstants.ReportCodes.Attend_Exceptions
        );
        break;
      case AppConstants.ReportCodes.Sub_Attend_MissingEvents:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) =>
            s.reportTypeCode ==
            AppConstants.ReportCodes.Sub_Attend_MissingEvents
        );
        break;
      case AppConstants.ReportCodes.Attend_Tamat:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) => s.reportTypeCode == AppConstants.ReportCodes.Attend_Tamat
        );
        break;
      case AppConstants.ReportCodes.Attend_Events:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) => s.reportTypeCode == AppConstants.ReportCodes.Attend_Events
        );
        break;
      case AppConstants.ReportCodes.Attend_Health_Declaration:
        arr = this.reportLayoutsTypesDataSource.filter(
          (s) =>
            s.reportTypeCode ==
            AppConstants.ReportCodes.Attend_Health_Declaration
        );
        break;
      default:
        break;
    }

    // arr.unshift({
    //   layoutId: 0,
    //   name: "",
    // });

    this.reportLayoutsTypesDataSourceFilterd = arr;
  }

  getReportLayoutsTypes() {
    let allowedReportsLayout = this.appEnv.UserInfo.availableReportLayoutIds as Array<any>;

    return this.reportLayoutsTypesDataSourceFilterd.filter(x => x.dynamicReportId == 0 || allowedReportsLayout.includes(x.dynamicReportId)).map((e) => {
      let isSystemReport = e.layoutId > 0;
      return {
        value: `${isSystemReport
            ? `system_${e.layoutId}`
            : `customer_${e.dynamicReportId}`
          }`,
        label: isSystemReport
          ? `${e.name} (${this.$t("fields.isSystem")})`
          : `${e.name}`,
        isSystemReport: isSystemReport,
      };
    });


  }

  get isKioskMode() {
    return AppConstants.IsKioskMode;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get currentSelectedEmployees() {
    return store.state.currentSelectedEmployees;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
